import type { UsageUnit } from '@/lib/usageCost.ts';

export const VENDOR_NAMES: Record<string, string> = {
  anthropic: 'Anthropic',
  azure: 'Azure',
  recall: 'Recall',
  assemblyai: 'AssemblyAI',
  elevenlabs: 'ElevenLabs',
};

export const vendorName = (vendor: string): string => VENDOR_NAMES[vendor] ?? vendor;

const compact = new Intl.NumberFormat(undefined, {
  notation: 'compact',
  maximumFractionDigits: 1,
});
const hours = new Intl.NumberFormat(undefined, { maximumFractionDigits: 1 });

export const formatTokens = (value: number): string => compact.format(value);
export const formatCount = (value: number): string =>
  new Intl.NumberFormat(undefined).format(value);
export const formatPercent = (value: number): string => `${(value * 100).toFixed(1)}%`;

/* Seconds read as hours: that is what Recall and AssemblyAI put on the invoice. */
export function formatQuantity(quantity: number, unit: UsageUnit): string {
  switch (unit) {
    case 'tokens':
      return `${compact.format(quantity)} tokens`;
    case 'characters':
      return `${compact.format(quantity)} chars`;
    case 'audio_seconds':
    case 'bot_seconds':
      return `${hours.format(quantity / 3600)} h`;
  }
}

export function share(value: number, total: number): string {
  return total <= 0 ? '—' : formatPercent(value / total);
}
